import { Singleton } from "../di/decorators.js";
const GLOBAL_PROVIDERS = new Set();
function Global(options) {
    return function(target) {
        Singleton(options)(target);
        GLOBAL_PROVIDERS.add(target);
        return target;
    };
}
function getGlobalProviders() {
    return Array.from(GLOBAL_PROVIDERS);
}
function isGlobalProvider(provider) {
    return GLOBAL_PROVIDERS.has(provider);
}
export { Global, getGlobalProviders, isGlobalProvider };
